module.exports = __webpack_public_path__ + "img/active_02.e82303aa.jpg";